<template>
  <div style="margin-top:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Group Message Sender</span><br/>
      <span style="font-style: italic; font-size: 18px">Send an SMS or email to a group of users.  Filter users by type or tag to narrow the recipients.</span>
      <div v-if="test_mode" style="font-weight: bold; color: darkred; font-style: italic; font-size: 18px">this feature is in test mode and will not send any SMSs or emails - to enable set 'Test Mode' to False in settings</div>
    </div>

    <div class="row" style="font-size: 22px; font-weight: bold; margin: 10px 30px 10px 30px">
        <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">Filter By User Type:&nbsp;<b-form-select v-model="user_type" :options="user_type_options" style="font-size: 20px; font-weight: bold; width:230px"/></div>
        <div style="padding: 10px;" v-if="user_type.indexOf('_drivers') != -1" class="col d-flex align-items-center justify-content-center">
          Time Available:&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:220px" v-model="driverStartTime" :config="options" :placeholder="driverStartTime"></date-picker>
          &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:220px" v-model="driverEndTime" :config="options" :placeholder="driverEndTime"></date-picker>
    </div>
      <div style="padding: 10px; background-color: white" class="d-flex align-items-center justify-content-center"><b-button style="font-size: 20px; font-weight: bold; width:150px" v-on:click.prevent="load_data()">Find Users</b-button></div>
      </div>
    <div class="row" style="font-size: 22px; font-weight: bold; margin: 10px 30px 10px 30px">
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">Message Format:&nbsp;<b-form-select v-model="message_type" :options="message_type_options" style="font-size: 20px; font-weight: bold; width:120px"/></div>
      <div style="padding: 10px;text-align: left" class="col">
        <b-form-textarea v-model="message_body" style="width:900px" rows="3" placeholder="Enter a message here."/>
        <span style="padding: 10px; font-size: 16px; font-style: italic">variables: [FirstName], [LastName], [FullName]</span>
      </div>
      <div style="padding: 10px; background-color: white" class="d-flex align-items-center justify-content-center">
        <span style="width:150px">
          <b-button v-if="items && items.length > 0 && !search_filter" size="lg" variant="success" v-on:click.prevent="send_to_group()">Send {{message_type}}</b-button>
        </span>
      </div>
    </div>
    <div class="row" style="font-size: 20px; font-weight: bold; margin: 10px 20px 10px 20px">
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">Showing: {{items.length}} of {{items_full.length}}</div>
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">
        Tag:&nbsp;<b-form-select v-model="tag_filter" :options="tag_options" style="font-size: 20px; font-weight: bold; width:200px"/>
      </div>
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">
        Job:&nbsp;<b-form-select v-model="job_title_filter" :options="job_title_options" style="font-size: 20px; font-weight: bold; width:200px"/>
      </div>
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">
        Location:&nbsp;<b-form-select v-model="company_location_filter" :options="location_options" style="font-size: 20px; font-weight: bold; width:200px"/>
      </div>
      <div style="padding: 10px;" class="col d-flex align-items-center justify-content-center">
        Search:&nbsp;<b-form-input style="width: 150px" v-model="search_filter" placeholder=""/>
      </div>
    </div>

    <div style="margin:20px">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="first_driver_start_time" slot-scope="row">
            {{row.item.first_driver_start_time | formatDateTimeSmall}}
        </template>

        <template slot="last_driver_end_time" slot-scope="row">
          {{row.item.last_driver_end_time | formatDateTimeSmall}}
        </template>

        <template slot="actions" slot-scope="row">
          <b-button size="sm" variant="success" v-on:click.prevent="send_to_user(row.item)">Send</b-button>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {get_groupsender_user_list, send_message_to_group, send_message_to_user} from '../networking/apis'
      import {mapState} from "vuex";
      import moment from "moment";

      export default {
        name: 'group_message_sender',
        components: {
      },

      data() {
        return {
          test_mode: false,
          driver_available: '',
          msg: 'users',
          search_filter: '',
          message_type: 'SMS',
          message_body: '',
          job_title_filter: '',
          job_title_options: [],
          company_location_filter: '',
          location_options: [],
          user_type: 'users',
          tag_filter: '',
          tag_options: [],
          driver_tag_filter: '',
          items: [],
          items_full: [],
          summary: [],
          loading: true,
          totalRows: 1,
          currentPage: 1,
          perPage: 400,
          pages: [],
          user_type_options: [
            { value: '', text: 'All Users' },
            { value: 'users', text: 'Portal Users' },
            { value: 'drivers', text: 'All Drivers' },
            // { value: 'available_drivers', text: 'Available Drivers' },
            // { value: 'unavailable_drivers', text: 'Unavailable Drivers' },
          ],
          message_type_options: [
            { value: 'SMS', text: 'SMS' },
            { value: 'EMAIL', text: 'Email' },
          ],
          fields_all: [],
          fields: [
            { key: 'type', label: 'Type', sortable: true},
            { key: 'email', label: 'Email Address', sortable: true},
            { key: 'name', label: 'Name', sortable: true},
            { key: 'tags', label: 'Tags', sortable: true},
            { key: 'job_title', label: 'Job Title', sortable: true},
            { key: 'company_location', label: 'Location', sortable: true},
            { key: 'phone', label: 'Phone #', sortable: true},
            // { key: 'first_driver_start_time', label: 'Driver Start Time', sortable: true},
            // { key: 'last_driver_end_time', label: 'Driver End Time', sortable: true},
            { key: 'actions', label: '', sortable: true},
          ],
          driverStartTime: moment(),
          driverEndTime: moment().add(12, 'hours'),
          options: {
            format: 'MM-DD-YY hh:mm a',
            useCurrent: true,
            minDate: moment().subtract(1,'days'),
            maxDate: moment().add(7, 'days'),
            keepOpen: false,
            showClear: true,
            showClose: true,
          },

        }
      },

      async created() {
        this.fields_all = this.fields
        await this.check_cols()
        await this.load_data()
      },
      methods: {
        async check_cols() {
          this.fields = this.fields_all
          if (this.user_type != 'unavailable_drivers')
              this.fields = this.fields.filter(item => (item.key != 'first_driver_start_time' && item.key != 'last_driver_end_time'))
        },
        async send_to_group() {
          this.$emit('showAlert', "sending messages to group...", 'info')
          const request_body = {
              "user_type": this.user_type,
              "driverStartTime": moment(this.driverStartTime, 'MM-DD-YY hh:mm').format('YYYY-MM-DDTHH:mm:ssZ'),
              "driverEndTime": moment(this.driverEndTime, 'MM-DD-YY hh:mm').format('YYYY-MM-DDTHH:mm:ssZ'),
              "tag_filter": this.tag_filter,
              "job_title_filter": this.job_title_filter,
              "company_location_filter": this.company_location_filter,
              "message_body": this.message_body,
              "message_type": this.message_type
          }
          await send_message_to_group(this.user.tenant, request_body)
          this.$emit('showAlert', "messages have been sent", 'success', 5000)
        },
        async send_to_user(user) {
          this.$emit('showAlert', "sending messages to user...", 'info')
          const request_body = {
              "user": user,
              "message_body": this.message_body,
              "message_type": this.message_type
          }
          await send_message_to_user(this.user.tenant, request_body)
          this.$emit('showAlert', "message has been sent", 'success', 5000)
        },
        async load_data() {
          this.loading = true
          try {
            const {value: { data = [] } } = await get_groupsender_user_list(this.user.tenant, this.user_type, moment(this.driverStartTime, 'MM-DD-YY hh:mm').format('YYYY-MM-DDTHH:mm:ssZ'), moment(this.driverEndTime, 'MM-DD-YY hh:mm').format('YYYY-MM-DDTHH:mm:ssZ'))
            this.items = data.results
            this.items_full = data.results
            this.job_title_options = data.summary.job_titles
            this.tag_options = data.summary.tags
            this.location_options = data.summary.locations
            this.test_mode = data.summary.test_mode
            this.filter_results()
          } catch(e) {
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
          }
          this.loading = false
        },
        filter_results() {
          this.items = this.items_full
          if (this.message_type == 'EMAIL')
            this.items = this.items.filter(item => (item.email && item.email.indexOf('@') != -1))
          if (this.message_type == 'SMS')
            this.items = this.items.filter(item => (item.phone))
          if (this.tag_filter != '')
            this.items = this.items.filter(item => (item.tags && item.tags.toLowerCase().indexOf(this.tag_filter.toLowerCase()) != -1))
          if (this.job_title_filter != '')
            this.items = this.items.filter(item => (item.job_title && item.job_title.toLowerCase().indexOf(this.job_title_filter.toLowerCase()) != -1))
          if (this.company_location_filter != '')
            this.items = this.items.filter(item => (item.company_location && item.company_location.toLowerCase().indexOf(this.company_location_filter.toLowerCase()) != -1))
          if (this.search_filter != '') {
            const val = this.search_filter
            this.items = this.items.filter(item => (this.contains(item.name, val) || this.contains(item.company_location, val) || this.contains(item.job_title, val) || this.contains(item.phone, val) || this.contains(item.email, val) || this.contains(item.tags, val)))
          }
        },
        contains(val1, val2) {
          if (val1 != null) {
            return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
          }
          return false;
        }
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.load_data()
          }
        },
        user_type() {
          this.check_cols()

          if (this.user_type.indexOf("_drivers") == -1)
            this.load_data()
          else
            this.items = []
            this.items_full = []
        },
        tag_filter() {
          this.filter_results()
        },
        message_type() {
          this.filter_results()
        },
        company_location_filter() {
          this.filter_results()
        },
        job_title_filter() {
          this.filter_results()
        },
        search_filter() {
          this.filter_results()
        }
      }
    }
</script>

<style>
  .error td { background-color: rgba(255,0,0,0.25)}
  .success td {background-color: hsla(120,100%,75%,0.3)}
  .unprocessed td { background-color: hsla(200,40%,80%,0.3) }
  .cancelled td { background-color: hsla(290,60%,70%,0.3) }

  div.row:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  .header {
    font-weight: bold;
  }

  div.col {
    border: 1px solid grey;
  }

  .table td {
    padding: .1rem !important;
  }

  .list-text {
    text-align: left;
    margin-top: 7px;
    margin-left: 7px;
  }

  .list-option {
    text-align: left;
    margin: 2px;
  }
</style>

